import { render, staticRenderFns } from "./_totalMiniGameCoinUsedDetail.vue?vue&type=template&id=26c338b5&lang=pug"
import script from "./_totalMiniGameCoinUsedDetail.vue?vue&type=script&lang=js"
export * from "./_totalMiniGameCoinUsedDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports